<div class="font-wrapper">
  <h3>{{ "settings.customization.brand-settings.variables.font-formatting" | translate }}</h3>
  <div class="font-item">
    <p class="font-title">{{ "settings.customization.fonts.font" | translate }}</p>
    <mat-form-field appearance="outline" floatLabel="auto">
      <mat-select
        [(ngModel)]="textProperties.font"
        [style.width]="'240px'"
        (ngModelChange)="validateFont(BrandVarEntity.Font)"
        [style.font-family]="textProperties.font"
        panelClass="font-set-panel">
        <mat-optgroup [label]="'campaign.widget.sidebar.edit.text.custom-fonts' | translate">
          @for (font of customFonts; track font) {
            <mat-option [value]="font.name">
              <span [style.font-family]="font.name">{{ font.name }}</span>
            </mat-option>
          }
        </mat-optgroup>
        <mat-optgroup [label]="'campaign.widget.sidebar.edit.text.standard-fonts' | translate">
          @for (font of defaultFonts; track font) {
            <mat-option [value]="font.name">
              <span [style.font-family]="font.name">{{ font.displayName }}</span>
            </mat-option>
          }
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
    <button class="secondary-button transparent-button" (click)="openFontFamilyFlyout.emit()">
      <span class="btn-label">
        +
        <span class="text-add">{{ "generic.add" | translate }}</span>
      </span>
    </button>
  </div>

  <div class="font-item">
    <p class="font-title">{{ "campaign.widget.sidebar.edit.text.font-size" | translate }}</p>
    <div class="input-wrapper">
      <mat-form-field class="small-input-field" appearance="outline" floatLabel="auto">
        <input
          matInput
          [ngModel]="textProperties.fontSize | unitExtractor"
          type="number"
          [step]="units.fontSize === 'px' ? 1 : 0.1"
          inputmode="numeric"
          (input)="validateFont(BrandVarEntity.FontSize, $event)"
          (keydown)="onArrowKey(BrandVarEntity.FontSize, $event)" />
      </mat-form-field>
      <mat-form-field class="px-or-percent-dropdown">
        <mat-select [(ngModel)]="units.fontSize" (ngModelChange)="validateFont(BrandVarEntity.FontSize)">
          @for (unit of AVAILABLE_UNITS; track unit) {
            <mat-option [value]="unit">{{ unit }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (brandVariablesErrorsVar.fontSize) {
        <mat-hint class="error">* {{ brandVariablesErrorsVar.fontSize }}</mat-hint>
      }
    </div>
    <div></div>
  </div>

  <div class="font-item">
    <p class="font-title">{{ "settings.customization.fonts.weight" | translate }}</p>
    <mat-form-field appearance="outline" floatLabel="auto">
      <mat-select
        [(ngModel)]="textProperties.fontWeight"
        (ngModelChange)="validateFont(BrandVarEntity.FontWeight)"
        [ngStyle]="{ 'font-family': textProperties.font, 'font-weight': textProperties.fontWeight }">
        @for (option of AVAILABLE_FONT_WEIGHTS; track option) {
          <mat-option [value]="option" [style.fontFamily]="textProperties.font" [style.fontWeight]="option">
            <span>{{ option }}</span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div></div>
  </div>

  <div class="font-item">
    <p class="font-title">{{ "campaign.widget.sidebar.edit.text.line-height" | translate }}</p>
    <div class="input-wrapper">
      <mat-form-field class="small-input-field" appearance="outline" floatLabel="auto">
        <input
          matInput
          [ngModel]="textProperties.lineHeight | unitExtractor"
          type="number"
          [step]="units.lineHeight === 'px' ? 1 : 0.1"
          inputmode="decimal"
          (input)="validateFont(BrandVarEntity.LineHeight, $event)"
          (keydown)="onArrowKey(BrandVarEntity.LineHeight, $event)" />
      </mat-form-field>
      <mat-form-field class="px-or-percent-dropdown">
        <mat-select [(ngModel)]="units.lineHeight" (ngModelChange)="validateFont(BrandVarEntity.LineHeight)">
          @for (unit of AVAILABLE_UNITS; track unit) {
            <mat-option [value]="unit">{{ unit }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (brandVariablesErrorsVar.lineHeight) {
        <mat-hint class="error">* {{ brandVariablesErrorsVar.lineHeight }}</mat-hint>
      }
    </div>
    <div></div>
  </div>

  <div class="font-item">
    <p class="font-title">{{ "settings.customization.brand-settings.variables.letter-spacing" | translate }}</p>
    <div class="input-wrapper">
      <mat-form-field class="small-input-field" appearance="outline" floatLabel="auto">
        <input
          matInput
          [ngModel]="textProperties.letterSpacing | unitExtractor"
          type="number"
          [step]="units.letterSpacing === 'px' ? 1 : 0.1"
          inputmode="decimal"
          (input)="validateFont(BrandVarEntity.LetterSpacing, $event)"
          (keydown)="onArrowKey(BrandVarEntity.LetterSpacing, $event)" />
      </mat-form-field>
      <mat-form-field class="px-or-percent-dropdown">
        <mat-select [(ngModel)]="units.letterSpacing" (ngModelChange)="validateFont(BrandVarEntity.LetterSpacing)">
          @for (unit of AVAILABLE_UNITS; track unit) {
            <mat-option [value]="unit">{{ unit }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (brandVariablesErrorsVar.letterSpacing) {
        <mat-hint class="error">* {{ brandVariablesErrorsVar.letterSpacing }}</mat-hint>
      }
    </div>
    <div></div>
  </div>
</div>
